import { useQuery } from '@tanstack/react-query';
import { useToast } from '@/components/atoms/Toast';
import { getAdminTokenEncrypt } from '@/services/apiKeyService';
import { useSelector } from 'react-redux';
import { RootState } from '@/rootReducer';
import { UserRole } from '@/modules/user/userTypes';

export const useAdminTokenEncryptQuery = () => {
	const { toast } = useToast();
	const user = useSelector((state: RootState) =>
		state.user.getIn(['authorize', 'user']).toJS()
	);
	const isAdmin = user?.role === UserRole.Admin || user?.role === UserRole.VA
	return useQuery({
		queryKey: ['admin-token-encrypt'],
		queryFn: getAdminTokenEncrypt,
		enabled: isAdmin,
		onError: error => {
			// eslint-disable-next-line no-console
			console.error({ error });

			const errorMessage = {
				title: 'Something unexpected happened',
				description: 'Please try again or contact support'
			};

			toast({
				...errorMessage,
				variant: 'error'
			});
		}
	});
};
